import { readableColor } from "polished";
import { useAuth } from "../../contexts/AuthContext";
import { useTheme } from "../../contexts/ThemeContext";

export const ResumeCourses = ({ children }) => {
  const theme = useTheme();
  const { lang } = useAuth();
  return (
    <>
      {/* <div className="vacio" style={{backgroundColor:theme.colors.backgroundBajada}}></div>
      <div style={{backgroundColor:theme.colors.backgroundBajada}}>
      <div className="px-8 mx-auto tablet:max-w-[740px] laptop:max-w-[1124px] desktop:max-w-[1380px]" >
         */}
        {/*         <p className="bajada-tit" style={theme.styles.text}>
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
          commodo ligula eget dolor.{" "}
          </p> */}
      {/* </div> */}
         {/*  </div> */}
      {/* <div className="vacio" style={{backgroundColor:theme.colors.backgroundBajada}}></div> */}
      <div className="wrapper fon-sec-car !p-12" style={{backgroundColor:theme.colors.backgroundColorBody}}>
        {/* <div className="container"> */}
        <div className="container mx-auto max-w-[1420px] ">
          <div className="col-md-12">
            <div className="row d-flex justify-content-center">
              {/* <div className="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 gap-6 tablet:gap-19 justify-items-center">
                {children}
              </div> */}
              <h1 className="tit-color font-outfit font-semibold px-3" style={{color: readableColor(theme.colors.backgroundColorBody, theme.colors.textColorNavbar)}}>
          {lang["Home"].title}
        </h1>
              <div className="grid grid-cols-1 min-[700px]:grid-cols-2 laptop:grid-cols-3 min-[1380px]:grid-cols-4 gap-6 tablet:gap-8 justify-items-center">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="wrapper fon-sec-car22 sale-desktop entra-movil">
        <div className="container">
          <p className="cargar-mas">Cargar más</p>
        </div>
      </div> */}
     {/*  <div className="vacio"></div> */}
    </>
  );
};
